@if (!tieneCredenciales) {
  <mat-card class="aviso-creds">
    <mat-card-content>
      <mat-icon color="warn">key</mat-icon>
      <div class="aviso-texto">
        <h3>Credenciales de seguridad no configuradas</h3>
        <p>
          Para ver los vecinos es necesario colocar tus credenciales de usuario
          del sistema de seguridad.
          <br />
          <strong>
            Configuración → Configurar usuario → Credenciales de Seguridad
          </strong>
          .
        </p>
      </div>
    </mat-card-content>
  </mat-card>
} @else {
  <app-tabla
    [totalCount]="totalCount"
    [datos]="datos"
    [columnas]="columnas"
    [name]="name"
    [pageSizeOptions]="helper.pageSizeOptions"
    [search]="search"
    [filtros]="filtros"
    [exportar]="botonExportar"
    [(query)]="query"
    (queryChange)="listar()"
    [paginatorArriba]="false"
    [showHijos]="false"
    [emptyState]="{ title: 'Todavía no hay vecinos' }"
  ></app-tabla>
}
